import axios from 'axios';
import { API_URL, securityHeaders } from '../Constants';
import { useMutation, useQuery } from 'react-query';

const fetchHomePage = async () => {
  return await axios.get(API_URL + `/api/HomePage`, {
    headers: securityHeaders,
  });
};

const deleteSlider = (id) => {
  return axios.post(
    API_URL + `/api/HomePage/DeleteHomePage/${id}`,
    {},
    {
      headers: securityHeaders,
    }
  );
};

const fetchSliderById = async (id) => {
  return await axios.get(API_URL + `/api/HomePage/GetHomePageById/${id}`, {
    headers: securityHeaders,
  });
};

export const useFetchHomePage = () => {
  return useQuery({
    queryKey: ['homePage'],
    queryFn: () => fetchHomePage(),
    enabled: true,
    refetchOnWindowFocus: false,
  });
};

export const useDeleteSlider = (id) => {
  return useMutation(() => deleteSlider(id));
};

export const useFetchSliderById = (id) => {
  return useQuery({
    queryKey: ['event', id],
    queryFn: () => fetchSliderById(id),
    enabled: false,
    refetchOnWindowFocus: false,
  });
};
